export const environment = {
    production: false,
    apiUrl: 'http://localhost:1337/api/v1',
    portalLinks: {
        login: 'http://localhost:4201/login',
        registration: 'http://localhost:4201/registration'
    }
}